import React from "react";
import ContentLoader from "react-content-loader";
import "../App.css";

const TableLoader = ({
  rows = 5,
  columns = 3,
  rowHeight = 30,
  // Keep these props, but note that width="100%" can't go directly into the viewBox
  width = "100%", 
  height = 300
}) => {
  const rowPadding = 10; 
  const columnGap = 5; 
  const colWidth = `calc(${Math.floor(100 / columns)}% - ${columnGap}px)`;
  const titleHeight = 40; 
  const titlePaddingBottom = 15; 
  const bottomRectWidth = 450; 
  const bottomRectHeight = 40; 
  const bottomPaddingTop = 0; 

  // We must use numeric values in viewBox. If width is "100%", pick a fixed numeric fallback (e.g. 1200).
  const numericViewBoxWidth = 1200;
  const numericViewBoxHeight =
    titleHeight +
    titlePaddingBottom +
    rows * (rowHeight + rowPadding) +
    bottomRectHeight +
    bottomPaddingTop;

  return (
    <ContentLoader
      speed={2}
      // You can still use "100%" for the overall <svg width> so it fills parent width.
      width={width}
      height={height + titleHeight + titlePaddingBottom + bottomRectHeight + bottomPaddingTop}
      // But the viewBox must be numeric:
      viewBox={`0 0 ${numericViewBoxWidth} ${numericViewBoxHeight}`}
      backgroundColor="#00000017"
      foregroundColor="#00000030"
    >
      {/* Title Rectangle */}
      <rect
        x="0"
        y="0"
        rx="5"
        ry="5"
        width="200px"
        height={titleHeight}
      />

      {/* Table Rows */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <React.Fragment key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <rect
              key={colIndex}
              x={`calc(${(colIndex * 100) / columns}% + ${colIndex * columnGap}px)`}
              y={titleHeight + titlePaddingBottom + rowIndex * (rowHeight + rowPadding)}
              rx="5"
              ry="5"
              width={colWidth}
              height={rowHeight}
            />
          ))}
        </React.Fragment>
      ))}

      {/* Bottom-Right Rectangle */}
      <rect
        x={`calc(100% - ${bottomRectWidth}px)`}
        y={titleHeight + titlePaddingBottom + rows * (rowHeight + rowPadding) + bottomPaddingTop}
        rx="5"
        ry="5"
        width={`${bottomRectWidth}px`}
        height={`${bottomRectHeight}px`}
      />
    </ContentLoader>
  );
};

export default TableLoader;